// Helpers for the free "find live tracking" flow on the Track page (no paid API, no account needed).
// A container number = 4-letter owner/category code (the shipping line) + 6 digits + 1 check digit (ISO 6346).

// Official free tracking pages of the main shipping lines. `link(number)` is used when the line accepts the
// number in the URL, otherwise the visitor lands on the line's tracking page and pastes the (auto-copied) number.
// `prefixes` = owner codes (first 4 letters of the container number).
export const CARRIERS = [
  { name: 'Maersk', prefixes: ['MAEU', 'MSKU', 'MRKU', 'MRSU', 'MWCU', 'MNBU', 'SUDU'],
    url: 'https://www.maersk.com/tracking/', link: (n) => `https://www.maersk.com/tracking/${n}` },
  { name: 'MSC', prefixes: ['MSCU', 'MEDU'],
    url: 'https://www.msc.com/en/track-a-shipment' },
  { name: 'CMA CGM / APL', prefixes: ['CMAU', 'CGMU', 'APLU', 'APZU', 'ANNU'],
    url: 'https://www.cma-cgm.com/ebusiness/tracking' },
  { name: 'Hapag-Lloyd', prefixes: ['HLXU', 'HLCU', 'HLBU', 'UACU'],
    url: 'https://www.hapag-lloyd.com/en/online-business/track/track-by-container-solution.html' },
  { name: 'ONE (Ocean Network Express)', prefixes: ['ONEU', 'NYKU', 'MOLU', 'KKTU'],
    url: 'https://ecomm.one-line.com/one-ecom/manage-shipment/cargo-tracking' },
  { name: 'COSCO', prefixes: ['COSU', 'CCLU', 'CBHU', 'CSLU'],
    url: 'https://elines.coscoshipping.com/ebusiness/cargoTracking' },
  { name: 'ZIM', prefixes: ['ZIMU', 'ZCSU'],
    url: 'https://www.zim.com/tools/track-a-shipment' },
  // Evergreen: official public "Cargo Tracking" (accepts container, B/L and booking numbers) via the ShipmentLink portal
  { name: 'Evergreen', prefixes: ['EGHU', 'EISU', 'EITU', 'EGSU', 'EMCU'],
    url: 'https://ct.shipmentlink.com/servlet/TDB1_CargoTracking.do' },
  { name: 'OOCL', prefixes: ['OOLU', 'OOCU'],
    url: 'https://www.oocl.com/eng/ourservices/eservices/cargotracking/Pages/default.aspx' },
  { name: 'HMM', prefixes: ['HDMU', 'HMMU'],
    url: 'https://www.hmm21.com/e-service/general/trackNTrace/TrackNTrace.do' },
  { name: 'Yang Ming', prefixes: ['YMLU', 'YMMU'],
    url: 'https://www.yangming.com/e-service/track_trace/track_trace_cargo_tracking.aspx' },
  { name: 'PIL (Pacific International Lines)', prefixes: ['PCIU', 'PILU'],
    url: 'https://www.pilship.com/' },
  { name: 'Wan Hai Lines', prefixes: ['WHLU'],
    url: 'https://www.wanhai.com/' },
];

// Free multi-carrier trackers that work for any shipping line
export const AGGREGATORS = [
  { name: 'SeaRates (free public tracker)', url: 'https://www.searates.com/container/tracking/' },
  { name: 'Track-Trace.com', url: 'https://www.track-trace.com/container' },
];

export const normalizeNumber = (raw) => String(raw || '').toUpperCase().replace(/[\s\-_.]/g, '');

export const looksLikeContainer = (n) => /^[A-Z]{3}[UJZR]\d{7}$/.test(n);

// ISO 6346 check digit (the 11th character)
export function hasValidCheckDigit(n) {
  if (!looksLikeContainer(n)) return false;
  const values = {};
  let v = 10;
  for (const ch of 'ABCDEFGHIJKLMNOPQRSTUVWXYZ') {
    if (v % 11 === 0) v += 1; // 11, 22, 33 are skipped
    values[ch] = v;
    v += 1;
  }
  let sum = 0;
  for (let i = 0; i < 10; i += 1) {
    const ch = n[i];
    const val = /[A-Z]/.test(ch) ? values[ch] : Number(ch);
    sum += val * 2 ** i;
  }
  return (sum % 11) % 10 === Number(n[10]);
}

export function detectCarrier(n) {
  if (!looksLikeContainer(n)) return null;
  const prefix = n.slice(0, 4);
  return CARRIERS.find((c) => c.prefixes.includes(prefix)) || null;
}
